const stageConfig = [
  {
    BRAND_CODE: 'anchor',
    VUE_APP_API_HOST: 'https://api.stage.clp.kr/anchor',
    VUE_APP_API_HOST_ENTERPRISE: 'https://api.stage.clp.kr/anchor',
    VUE_APP_API_HOST_STANDARD: 'https://api.stage.clp.kr/anchor',
    VUE_APP_PAYMENT_HOST: 'https://learner.stage.clp.kr/anchor',
    VUE_FIREBASE_INIT: {
      apiKey: 'AIzaSyCB-ZXsM01TQAambFKRmIrPO6O4UYxdFY8',
      authDomain: 'anchorguideproject.firebaseapp.com',
      databaseURL: 'https://anchorguideproject-default-rtdb.asia-southeast1.firebasedatabase.app',
      projectId: 'anchorguideproject',
      storageBucket: 'anchorguideproject.firebasestorage.app',
      messagingSenderId: '842682810154',
      appId: '1:842682810154:web:16b8460d737b72d24b6853',
      measurementId: 'G-3YXT7SH97D',
    },
    VUE_APP_PAYMENT_RETURN_HOST: 'https://dev-brk.clp.kr',
    VUE_COMMON_CSS: '',
    NAVER_KEY: 'T6LQWzBjzkodcp3xn2VQ',
    TELEGRAM_BOT: 'anchor_stg_learner_bot',
    TELEGRAM_URL: 'https://t.me/anchor_stg_learner_bot?linkType=INTERNAL_LINK',
    FAVICON_URL: 'https://m-dev.clp.kr/favicon.ico',
  },
];

export default stageConfig;
